const ALLOWED_PROTOCOLS = ['http:', 'https:'];

export const isSafeUrl = (url: string): boolean => {
  if (!url) {
    return false;
  }

  try {
    const { protocol } = new URL(url, window.location.origin);
    return ALLOWED_PROTOCOLS.includes(protocol);
  } catch {
    return false;
  }
};

export const redirectTo = (url: string): void => {
  if (isSafeUrl(url)) {
    window.location.assign(url);
  }
};
